import BlankOrder from '@components/blank/BlankOrder';
import Column from '@components/Column';
import Header from '@components/Header';
import InfinityScrollTrigger from '@components/InfinityScrollTrigger';
import Loading from '@components/Loading';
import TabItem from '@components/tab/TabItem';
import TabList from '@components/tab/TabList';
import { useStepFlow } from '@router/stackflow';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import OrderLog from './components/OrderLog';
import useOrderLogs from './hooks/useOrderLogs';
import styles from './styels.module.scss';

interface Params {
    duration: 'WEEK'| 'ONE_MONTH' | 'THREE_MONTH' | 'ALL'
}

const OrderLogsActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
    const { duration } = params;
    const { t } = useTranslation('orderLogs');
    const { stepReplace } = useStepFlow('OrderLogsActivity');
    const {
        orderLogs, fetchNextPage, isEmpty, isFetching,
    } = useOrderLogs(duration);
    return (
        <AppScreen>
            <Header title={t('header.title')} />
            <TabList variant='solid'>
                <TabItem selected={duration === 'WEEK'}
                    onClick={() => stepReplace({ duration: 'WEEK' })} >
                    {t('tabs.oneWeek')}
                </TabItem>
                <TabItem selected={duration === 'ONE_MONTH'}
                    onClick={() => stepReplace({ duration: 'ONE_MONTH' })} >
                    {t('tabs.oneMonth')}
                </TabItem>
                <TabItem selected={duration === 'THREE_MONTH'}
                    onClick={() => stepReplace({ duration: 'THREE_MONTH' })} >
                    {t('tabs.threeMonths')}
                </TabItem>
                <TabItem selected={duration === 'ALL'}
                    onClick={() => stepReplace({ duration: 'ALL' })} >
                    {t('tabs.sixMonths')}
                </TabItem>
            </TabList>
            <Column as='main'
                fullWidth
                spacing={18}
                align='center'
                className={styles.contents} >
                {orderLogs?.map((order) => (
                    <OrderLog order={order}
                        key={order.orderNo} />
                ))}
                {isEmpty && (
                    <BlankOrder/>
                )}
                {isFetching && (
                    <Loading size='small'/>
                )}
                <InfinityScrollTrigger trigger={fetchNextPage}/>
            </Column>
        </AppScreen>
    );
};

export default OrderLogsActivity;
